<template>
  <div id="message">
    <Table style="font-size:20px" border stripe :columns="columns1" :data="TemplateData">
      <template slot-scope="{ row, index }" slot="config">
        <Button @click="config(row)">修改</Button>
        <Button style="margin-left: 10px;" @click="Delete(row)">删除</Button>
      </template>
    </Table>
    <Modal v-model="configMessage" :title="configTitle" width="700px" @on-ok="updatedMessage">
      <div class="config">
        <div class="title">模板id</div>
        <Input v-model="updated.templateId" placeholder="模板id"></Input>
      </div>
      <div class="config">
        <div class="title">标题</div>
        <Input v-model="updated.title" placeholder="标题"></Input>
      </div>

      <div class="config">
        <div class="title">first</div>
        <Input v-model="updated.first.name" placeholder="first"></Input>
        <div style="margin-left:20px" class="title">颜色</div>
        <input v-model="updated.first.color" type="color" />
      </div>
      <div class="config">
        <div class="title">remark</div>
        <Input v-model="updated.remark.name" placeholder="remark"></Input>
        <div style="margin-left:20px" class="title">颜色</div>
        <input v-model="updated.remark.color" type="color" />
      </div>

      <div>
        <div v-for="(data,index) in updated.keywords" class="config">
          <div class="title">{{'keyword'+index}}</div>
          <Input v-model="data.name" placeholder="标题"></Input>
          <div style="margin-left:20px;width: 85px;" class="title">颜色</div>
          <input v-model="data.color" type="color" />
          <Button @click="deleteKeywords(index)" style="margin-left: 15px;">删除</Button>
        </div>
      </div>
      <Button @click="AddKeywords()" style="margin-left: 15px;">新增</Button>
    </Modal>
    <Modal v-model="deleteOk" title="删除！！" @on-ok="ok">删除！！！</Modal>
    <Button @click="Add()" style="float: right;margin-top: 15px;">新增</Button>
    <Page @on-change="pagingSuery" style="margin-top:15px;float: left;" :total="total"></Page>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "message",
  data() {
    return {
      pageNow: 1,
      deleteOk: false,
      configTitle: "",
      configMessage: false,
      updated: { keywords: [{}], first: {}, remark: {} },
      total: 0,
      TemplateData: [],
      columns1: [
        {
          title: "模板id",
          align: "center",
          key: "templateId"
        },
        {
          title: "标题",
          align: "center",
          key: "title"
        },
        {
          title: "创建时间",
          align: "center",
          key: "createTime"
        },
        {
          title: "修改时间",
          align: "center",
          key: "modifyTime"
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          slot: "config"
        }
      ]
    };
  },
  mounted: function() {
    this.getData();
  },
  activated: function() {},

  methods: {
    getData() {
      api.WtempList({ pageNow: this.pageNow }).then(res => {
        this.total = res.body.data.total;
        this.TemplateData = res.body.data.list;
      });
    },
    Add() {
      this.configTitle = "新增模板";
      this.configMessage = true;
      this.updated = { keywords: [{}], first: {}, remark: {} };
    },
    deleteKeywords(index) {
      this.updated.keywords.splice(index, 1);
    },
    AddKeywords() {
      this.updated.keywords.push({});
    },

    config(res) {
      this.configTitle = "修改模板";
      this.configMessage = true;
      this.updated = res;
      this.updated.keywords = JSON.parse(this.updated.keywords);
      this.updated.first = JSON.parse(this.updated.first);
      this.updated.remark = JSON.parse(this.updated.remark);
    },
    updatedMessage() {
      for (let i = 0; i < this.updated.keywords.length; i++) {
        this.updated.keywords[i].attr = "keyword" + (i + 1);
      }
      this.updated.first.attr = "first";
      this.updated.remark.attr = "remark";
      this.updated.keywords = JSON.stringify(this.updated.keywords);
      this.updated.first = JSON.stringify(this.updated.first);
      this.updated.remark = JSON.stringify(this.updated.remark);
      if (this.updated.id) {
        api.WtempEdit(this.updated).then(res => {
          this.getData();
        });
      } else {
        api.WtempAdd(this.updated).then(res => {
          this.getData();
        });
      }
    },
    Delete(res) {
      this.updated = res;
      this.deleteOk = true;
    },
    ok() {
      api.WtempDel(this.updated.id).then(res => {
        this.getData();
      });
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData();
    }
  }
};

// GetRewardTotal
</script>

<style scoped  >
#message {
  height: 100%;
  overflow: hidden;
}
.config {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.title {
  float: left;
  width: 200px;
}
</style>